import { render, staticRenderFns } from "./dict-classic.vue?vue&type=template&id=608efd85&"
import script from "./dict-classic.vue?vue&type=script&lang=js&"
export * from "./dict-classic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports